module.exports = __webpack_public_path__ + "static/media/workAntihumidity4.f0e2073e.jpg";